
const Main = () => import('@/views/main');
const appBanner = () => import('@/views/operation/appBanner');
const addBanner = () => import('@/views/operation/addBanner');

const appNews = () => import('@/views/operation/appInfo');
const addNews = () => import('@/views/operation/addInfo');

const channel = () => import('@/views/platform/channel');
const visitDetail = () => import('@/views/platform/visitDetail');

const orderInventory = () => import('@/views/platform/orderInventory');
const createInventory = () => import('@/views/platform/createInventory');
const amendScreening = () => import('@/views/platform/amendScreening');
const amendInventory = () => import('@/views/platform/amendInventory');
const closeInventory = () => import('@/views/platform/close-inventory');
const inventoryItemManage = () => import('@/views/platform/inventory-item-manage');

const thirdReserveManage = () => import('@/views/change-code/third-party');
const editReserve = () => import('@/views/change-code/third-party-manger');
const thirdPartySearch = () => import('@/views/change-code/third-party-search');

const miniTicketManage = () => import('@/views/operation/miniapp-tickets');

export default [{
    path: '/operation',
    name: 'operation',
    component: Main,
	redirect: {
		name: 'channel'
	},
    meta: {
        hide: false,
        name: '小程序运营管理',
        unfold: true,
		iconType: "20"
    },
    children: [
		{
			path: 'channel',
			name: 'channel',
			component: channel,
			meta: {
				name: '渠道管理'
			},
			children: [
				{
					path: "visitDetail",
					component: visitDetail,
					name: "visitDetail",
					meta: {
						name: '访问详情'
					},
				},
			]
		},
        {
            path: '/appBanner',
            name: 'appBanner',
            component: appBanner,
            meta: {
                name: '广告位管理'
            },
            children: [
                {
                    path: "addBanner",
                    component: addBanner,
                    name: 'addBanner',
                    meta: {
                        name: "新增广告位"
                    }
                },
                {
                    path: "updateBanner",
                    component: addBanner,
                    name: 'updateBanner',
                    meta: {
                        name: "编辑广告位"
                    }
                },
                {
                    path: "bannerDetail",
                    component: addBanner,
                    name: 'bannerDetail',
                    meta: {
                        name: "广告位详情"
                    }
                },

            ]
        },
        // {
        //     path: '/appNews',
        //     name: 'appNews',
        //     component: appNews,
        //     meta: {
        //         name: 'App资讯'
        //     },
        //     children: [
        //         {
        //             path: "addNews",
        //             component: addNews,
        //             name: 'addNews',
        //             meta: {
        //                 name: "新增资讯"
        //             }
        //         },
        //         {
        //             path: "updateNews",
        //             component: addNews,
        //             name: 'updateNews',
        //             meta: {
        //                 name: "编辑资讯"
        //             }
        //         },
        //         {
        //             path: "detailNews",
        //             component: addNews,
        //             name: 'detailNews',
        //             meta: {
        //                 name: "资讯详情"
        //             }
        //         },
        //     ]
        // },
        {
            path: "/orderInventory",
            component: orderInventory,
            name: "orderInventory",
            meta: {
                name: '官方预约管理'
            },
            children: [
                {
                    path: "createInventory",
                    component: createInventory,
                    name: "createInventory",
                    meta: {
                        name: '生成库存'
                    },
                },
                {
                    path: "amendScreening",
                    component: amendScreening,
                    name: "amendScreening",
                    meta: {
                        name: '修改场次时间'
                    },
                },
                {
                    path: "amendInventory",
                    component: amendInventory,
                    name: "amendInventory",
                    meta: {
                        name: '修改库存'
                    },
                },
                {
                    path: "closeInventory",
                    component: closeInventory,
                    name: "closeInventory",
                    meta: {
                        name: '批量关闭库存'
                    },
                },
                {
                    path: "inventoryItemManage",
                    component: inventoryItemManage,
                    name: "inventoryItemManage",
                    meta: {
                        name: "库存项目管理"
                    }
                }
            ]
        },
		{
			path: '/thirdReserveManage',
			name: 'thirdReserveManage',
			component: thirdReserveManage,
			meta: {
				name: '第三方预约管理'
			},
			children: [{
					path: 'editReserve',
					name: 'editReserve',
					component: editReserve,
					meta: {
						name: '预约管理'
					},
				},
                {
                    path: 'thirdPartySearch',
                    name: 'thirdPartySearch',
                    component: thirdPartySearch,
                    meta: {
                        name: '手机号查询'
                    },
                }
			]
		},
		{
			path: '/miniTicketManage',
			name: 'miniTicketManage',
			component: miniTicketManage,
			meta: {
				name: '小程序售票展示'
			},
		},
    ]
}]

